<template>
  <div id="home">
    <Cover />
    <Feature id="about" heading="About Me" backgroundColor="#ff6347">
      <b-col cols="8">
        <p>Hello.</p>
        <p>I'm Brett and I'm a geek</p>
        <div>
          I am a software developer professional with over 25 years of industry
          experience.
        </div>
      </b-col>
    </Feature>
    <Feature id="what-i-do" heading="What I do" backgroundColor="#1abc9c">
      <b-col cols="8">
        <div>Blogs</div>
        <div>Simple websites</div>
        <div>Online shopping</div>
        <div>Website maintenance</div>
        <div>Email campaigns</div>
        <div>API integration</div>
        <div>Data services</div>
        <div>Tuition</div>
      </b-col>
    </Feature>
    <div id="reviews" class="p-4 text-center">
      <p></p>
      <p>
        <b-button
          variant="outline-dark"
          href="https://www.facebook.com/pg/thegeekyhelpernz/reviews"
          target="_blank"
          rel="noopener noreferrer"
        >
          <b-icon-star-fill></b-icon-star-fill>
          REVIEWS</b-button
        >
      </p>
    </div>
    <Contact id="contact" />
    <div id="legal" class="p-4 text-center">
      <b-button to="/legal#disclaimer" variant="outline-light"
        >DISCLAIMER</b-button
      >
      &nbsp;
      <b-button to="/legal#privacy" variant="outline-light">PRIVACY</b-button>
    </div>
  </div>
</template>

<script>
import { BIconStarFill } from 'bootstrap-vue';

import Contact from '@/components/Contact.vue';
import Cover from '@/components/home/Cover.vue';
import Feature from '@/components/home/Feature.vue';

export default {
  name: 'Home',
  components: {
    BIconStarFill,
    Contact,
    Cover,
    Feature,
  },
};
</script>

<style scoped>
.badge {
  color: #1abc9c;
  background-color: #fff;
  margin-right: 1rem;
}

#reviews {
  color: #212529;
  background-color: #fbb034;
  background-image: linear-gradient(315deg, #fbb034 0%, #ffdd00 74%);
}

.btn-outline-dark:hover {
  color: #fff !important;
  text-decoration: none !important;
}

#legal {
  background-color: #212529;
}

#legal > a:hover {
  color: #212529 !important;
  text-decoration: none !important;
}
</style>
